import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { DetailedProductGroups } from "../../priceListTypes"
import { AdjustPricesFormValues, countProductsInGroups } from "./adjustPricesLib"
import { useScopeSelection } from "./useScopeSelection"

const useStyles = makeStyles()((theme) => ({
    subtitleEmpty: {
        color: theme.palette.error.dark,
    },
}))

type ScopeSubtitleProps = Readonly<{
    productGroups: ReadonlyArray<DetailedProductGroups>
}>

export function ScopeSubtitle({ productGroups }: ScopeSubtitleProps) {
    const { classes } = useStyles()
    const { values } = useFormikContext<AdjustPricesFormValues>()
    const { selected, isEverythingSelected } = useScopeSelection(productGroups)

    const selectedItemCount = countProductsInGroups(productGroups, values.productGroupIds)

    if (selected.size === 0) {
        return (
            <LocalizedStrict id="adjust-price-list-scope-subtitle-empty">
                <span className={classes.subtitleEmpty}>Choose at least one product group.</span>
            </LocalizedStrict>
        )
    }

    return (
        <LocalizedStrict
            id={isEverythingSelected ? "adjust-price-list-scope-subtitle-all" : "adjust-price-list-scope-subtitle-some"}
            vars={{ groups: selected.size, total: productGroups.length, items: selectedItemCount }}
        >
            <span>
                {selected.size} of {productGroups.length} groups · {selectedItemCount} items
            </span>
        </LocalizedStrict>
    )
}
